import { PbxHttpClient } from "@/services/httpclient";

export const dashboard = {
  namespaced: true,

  state: {
    dashboardDayValues: [],
    dashboardTipingDayValues: [],
    dashboardMonthValues: [],
    dashboardTipingMonthValues: [],
    dashboardWhatsappDayValues: [],
    dashboardWhatsappMonthValues: [],
  },

  getters: {
    GET_DASHBOARD_DAY(state) {
      return state.dashboardDayValues;
    },

    GET_DASHBOARD_TIPING_DAY(state) {
      return state.dashboardTipingDayValues;
    },

    GET_DASHBOARD_MONTH(state) {
      return state.dashboardMonthValues;
    },

    GET_DASHBOARD_TIPING_MONTH(state) {
      return state.dashboardTipingMonthValues;
    },
  },

  mutations: {
    SET_DASHBOARD_DAY(state, payload) {
      state.dashboardDayValues = payload;
    },

    SET_DASHBOARD_TIPING_DAY(state, payload) {
      state.dashboardTipingDayValues = payload;
    },

    SET_DASHBOARD_MONTH(state, payload) {
      state.dashboardMonthValues = payload;
    },

    SET_DASHBOARD_TIPING_MONTH(state, payload) {
      state.dashboardTipingMonthValues = payload;
    },

    SET_DASHBOARD_WHATSAPP_DAY(state, payload) {
      state.dashboardWhatsappDayValues = payload;
    },

    SET_DASHBOARD_WHATSAPP_MONTH(state, payload) {
      state.dashboardWhatsappMonthValues = payload;
    },
  },

  actions: {
    async DASHBOARD_DAY_VALUES({ commit }, payload) {
      try {
        const response = await PbxHttpClient.get(
          "/dashboardDay?yesterday=" +
            payload.yesterday +
            "&is_queue=" +
            payload.is_queue
        );
        commit("SET_DASHBOARD_DAY", response.data);
        return response;
      } catch (error) {
        Promise.reject(error);
      }
    },

    async DASHBOARD_TIPING_DAY_VALUES({ commit }, payload) {
      try {
        const response = await PbxHttpClient.get(
          "/report-dashboard-typing-day?yesterday=" +
            payload.yesterday
        );
        commit("SET_DASHBOARD_TIPING_DAY", response.data);
        return response;
      } catch (error) {
        Promise.reject(error);
      }
    },

    async DASHBOARD_WHATSAPP_DAY_VALUES({ commit }, payload) {
      try {
        const response = await PbxHttpClient.get(
          "/dashboard_whatsapp_day?yesterday=" + payload.yesterday
        );
        commit("SET_DASHBOARD_WHATSAPP_DAY", response.data);
        return response;
      } catch (error) {
        Promise.reject(error);
      }
    },

    async DASHBOARD_MONTH_VALUES({ commit }, payload) {
      try {
        const response = await PbxHttpClient.get(
          "/dashboard_Mounth?yesterday=" +
            payload.yesterday +
            "&is_queue=" +
            payload.is_queue
        );
        commit("SET_DASHBOARD_MONTH", response.data);
        return response;
      } catch (error) {
        Promise.reject(error);
      }
    },

    async DASHBOARD_TIPING_MONTH_VALUES({ commit }, payload) {
      try {
        const response = await PbxHttpClient.get(
          "/report-dashboard-mounth-typing?yesterday=" +
            payload.yesterday
        );
        commit("GET_DASHBOARD_TIPING_MONTH", response.data);
        return response;
      } catch (error) {
        Promise.reject(error);
      }
    },

    async DASHBOARD_WHATSAPP_MONTH_VALUES({ commit }, payload) {
      try {
        const response = await PbxHttpClient.get(
          "/dashboard_whatsapp_mounth?yesterday=" + payload.yesterday
        );
        commit("SET_DASHBOARD_WHATSAPP_MONTH", response.data);
        return response;
      } catch (error) {
        Promise.reject(error);
      }
    },
  },
};
